import React, { Component } from 'react'

import QuestionTranslate from './QuestionTranslate'
import SurveyTranslate from './SurveyTranslate'

import './translate.scss'

const Translate = ({
    question, isDisabled, defaultLocale, survey, locales, store, hasExistingData,
}) => (
    <div className="translate">
        {question && (
            <QuestionTranslate
                question={question}
                locales={locales}
                isDisabled={isDisabled}
                defaultLocale={defaultLocale}
                hasExistingData={hasExistingData}
            />
        )}
        {survey && <SurveyTranslate survey={survey} locales={locales} defaultLocale={defaultLocale} store={store} />}
    </div>
)

export default Translate
